const apiKey = import.meta.env.VITE_AUTHENTICATION_API_KEY;

if (!apiKey) {
  throw new Error("API Key is missing from environment variables.");
}

const setSettings = async (
  instanceId: string | undefined,
  rejectCall: boolean,
  msgCall: string,
  groupsIgnore: boolean,
  alwaysOnline: boolean,
  readMessages: boolean,
  readStatus: boolean
): Promise<any> => {
  try {
    const response = await fetch(`https://evolutionapi.cabanalink.com/settings/set/${instanceId}`, {
      method: 'POST',
      headers: {
        apikey: apiKey,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        rejectCall,
        msgCall,
        groupsIgnore,
        alwaysOnline,
        readMessages,
        readStatus,
        syncFullHistory: false
      })
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Erro ao inserir configurações:', error);
  }
}

const findSettings = async (instanceId: string | undefined): Promise<any> => {
  try {
    const response = await fetch(`https://evolutionapi.cabanalink.com/settings/find/${instanceId}`, {
      method: 'GET',
      headers: {
        apikey: apiKey,
        'Content-Type': 'application/json'
      },
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Erro ao encontrar configurações:', error);
  }
}

export {setSettings, findSettings};